import { useTheme } from '@mui/joy';
import { ChapterOptions } from '../types';

export const useChapterColors = () => {
	const theme = useTheme();

	const getColor = (chapter: ChapterOptions) => {
		if (chapter === 'donors') {
			return theme.colorSchemes.light.palette.chaptersDonors;
		} else if (chapter === 'candidates') {
			return theme.colorSchemes.light.palette.chaptersCandidates;
		} else if (chapter === 'opportunities') {
			return theme.colorSchemes.light.palette.chaptersOpportunities;
		} else if (chapter === 'analysis') {
			return theme.colorSchemes.light.palette.chaptersAnalysis;
		}
		return theme.colorSchemes.light.palette.chaptersCandidates;
	};

	return {
		getColor,
		theme,
		solidBg: (chapter: ChapterOptions) => getColor(chapter).solidBg
	};
};
